module.exports = __webpack_public_path__ + "img/18.dad663a6.webp";